import { render } from "./Login.vue?vue&type=template&id=4becfa3a&scoped=true"
import script from "./Login.vue?vue&type=script&lang=js"
export * from "./Login.vue?vue&type=script&lang=js"

import "./Login.vue?vue&type=style&index=0&id=4becfa3a&scoped=true&lang=scss"

import exportComponent from "/home/scotty/git/staging_pos/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4becfa3a"]])

export default __exports__